import {
  faFilter as thinFaFilter,
  faCirclePlus as thinFaCirclePlus,
  faFile as thinFaFile,
  faPencil as thinFaPencil,
  faCircleInfo as thinFaCircleInfo,
  faFileMagnifyingGlass,
} from '@fortawesome/pro-thin-svg-icons';

import {
  faBriefcase as duoBriefcase,
  faVirus as duoVirus,
  faBook as duoBook,
  faBookMedical as duoBookMedical,
  faChartLine as duoChartLine,
  faChartSimple as duoChartSimple,
  faCirclePlus as duoCirclePlus,
  faUpload as duoUpload,
  faDna as duoDna,
  faFlaskVial as duoFlaskVial,
  faGlobePointer as duoGlobePointer,
  faStethoscope as duoStethoscope,
  faTable as duoFaTable,
  faTableCells as duoTableCells,
  faVial as duoVial,
  faLoader as duoLoader,
  faCircleCheck as duoCircleCheck,
  faCircleExclamation as duoCircleExclamation,
  faPuzzle as duoPuzzle,
  faSitemap as duoSitemap,
  faUsers as duoUsers,
  faMagnifyingGlassChart as duoMagnifyingGlassChart,
  faChartNetwork as duoChartNetwork,
  faDiagramSankey as duoDiagramSankey,
  faHexagonNodes as duoHexagonNodes,
  faCircleInfo as duoCircleInfo,
  faArrowsSplitUpAndLeft as duoArrowsSplitUpAndLeft,
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faBarsProgress as regularFaBarsProgress,
  faFileShield as regularFaFileShield,
  faRepeat as regularFaRepeat,
  faPalette as regularFaPalette,
  faGear as regularFaGear,
  faRightFromBracket as regularFaRightFromBracket,
  faDiagramSankey as regularFaDiagramSankey,
  faCircleInfo as regularFaCircleInfo,
  faSplit as regularFaSplit,
  faVolcano as regularFaVolcano,
  faImageSlash as regularFaImageSlash,
  faStar as regularFaStar,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faCircleCheck as solidCircleCheck,
  faHourglassHalf as solidFaHourglassHalf,
  faOctagonExclamation as solidOctagonExclamation,
  faTimer as solidFaTimer,
  faTransporterEmpty as solidFaTransporterEmpty,
  faTrashCanXmark as solidFaTrashCanXmark,
  faPuzzle as solidPuzzle,
  faMerge,
  faTriangleExclamation,
  faMicrochipAi,
  faChevronRight,
  faChevronsRight,
  faArrowsUpToLine,
  faUsersMedical as solidUsersMedical,
  faFunction,
  faTablePivot,
  faFloppyDisk,
  faFloppyDiskPen,
  faBookmark,
  faLayerGroup,
  faUserShield,
  faDiagramSankey,
  faCode,
  faPlay,
  faHexagonNodes,
  faMagnifyingGlassChart,
  faChartNetwork,
  faClock,
  faStar as solidFaStar,
  faEye,
  faEyeSlash,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faBarsProgress,
  faDownload,
  faDrawPolygon,
  faCheck,
  faCircle,
  faCircleNotch,
  faClose,
  faCloudArrowDown,
  faComputer,
  faFileArrowUp,
  faFileExport,
  faFileImport,
  faFolderOpen,
  faFolderTree,
  faHouse,
  faTableCellsLarge,
  faTable,
  faTrashCan,
  faPenToSquare,
  faXmark,
  faGear,
  faDna,
  faBars,
  faMagnifyingGlass,
  faFilter,
  faFilterCircleXmark,
  faLink,
  faArrowUpRightFromSquare,
  faCircleCheck,
  faR,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faCirclePlus,
  faCircleMinus,
  faCaretLeft,
  faCaretRight,
  faFlaskVial,
  faCalendar,
  faCalendarDays,
  faVial,
  faChartArea,
  faChartLine,
  faUser,
  faCropSimple,
  faWandSparkles,
  faBriefcase,
  faStethoscope,
  faList,
  faBook,
  faBookMedical,
  faClipboard,
  faClipboardCheck,
  faPaste,
  faCaretDown,
  faCaretUp,
  faTableCells,
  faSpinner,
  faRightFromBracket,
  faFileArrowDown,
  faChevronDown,
  faChevronUp,
  faToggleOff,
  faToggleOn,
  faCircleArrowLeft,
  faPalette,
  faPencil,
  faPlus,
  faQuestion,
  faRotateRight,
  faUpload,
  faVirus,
  faSitemap,
  faArrowUpFromBracket,
  faFilePdf,
  faUsersGear,
  faMaximize,
  faMinimize,
  faBroom,
  faToolbox,
  faUserPlus,
  faUserGear,
  faUserMinus,
  faArrowRightFromBracket,
  faFileLines,
  faRankingStar,
  faDiagramProject,
  faAlignCenter,
  faScissors,
  faEllipsisVertical,
  faLock,
  faGlobe,
} from '@fortawesome/free-solid-svg-icons';
import { faDocker } from '@fortawesome/free-brands-svg-icons';

export const fontLibrary = [
  duoChartSimple,
  duoFaTable,
  duoFlaskVial,
  duoStethoscope,
  faBars,
  faFileImport,
  faFileExport,
  faFilter,
  faDrawPolygon,
  faMagnifyingGlass,
  faGear,
  faPlus,
  faFilterCircleXmark,
  faComputer,
  faTable,
  faDownload,
  faDna,
  faCircleNotch,
  faHouse,
  faFolderOpen,
  faFolderTree,
  faBarsProgress,
  faCirclePlus,
  faCircleMinus,
  faChartArea,
  faChartLine,
  faCropSimple,
  faTableCellsLarge,
  faTrashCan,
  faPenToSquare,
  faCheck,
  faXmark,
  faCloudArrowDown,
  faArrowUpRightFromSquare,
  faCircle,
  faCircleCheck,
  faR,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faCircleArrowLeft,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCaretDown,
  faFlaskVial,
  faCalendar,
  faCalendarDays,
  faVial,
  faUser,
  faArrowUpFromBracket,
  faFilePdf,
  faWandSparkles,
  faBriefcase,
  faStethoscope,
  faLink,
  faList,
  faBookMedical,
  faClipboard,
  faClipboardCheck,
  faPaste,
  faTableCells,
  faTablePivot,
  faSpinner,
  faRightFromBracket,
  faRotateRight,
  faFileArrowDown,
  duoGlobePointer,
  faChevronDown,
  faChevronUp,
  faChevronsRight,
  faChevronRight,
  faToggleOff,
  faToggleOn,
  duoTableCells,
  duoBriefcase,
  duoChartLine,
  duoVial,
  duoDna,
  duoBook,
  duoBookMedical,
  duoCirclePlus,
  duoUpload,
  duoCircleInfo,
  faPencil,
  faCode,
  regularFaBarsProgress,
  solidCircleCheck,
  solidFaHourglassHalf,
  solidOctagonExclamation,
  solidFaTimer,
  solidFaTransporterEmpty,
  solidFaTrashCanXmark,
  thinFaCirclePlus,
  thinFaFilter,
  faPalette,
  faUpload,
  faFileArrowUp,
  faClose,
  thinFaFile,
  thinFaPencil,
  faQuestion,
  duoLoader,
  duoCircleCheck,
  duoCircleExclamation,
  faTriangleExclamation,
  regularFaFileShield,
  faVirus,
  duoVirus,
  regularFaRepeat,
  regularFaPalette,
  regularFaGear,
  regularFaRightFromBracket,
  faSitemap,
  duoPuzzle,
  duoSitemap,
  duoUsers,
  faUsersGear,
  faFunction,
  solidPuzzle,
  faMaximize,
  faMinimize,
  faBroom,
  faToolbox,
  faUserPlus,
  faUserGear,
  faUserMinus,
  faArrowRightFromBracket,
  regularFaDiagramSankey,
  faFileMagnifyingGlass,
  faBook,
  faFileLines,
  faMerge,
  faMicrochipAi,
  faArrowsUpToLine,
  solidUsersMedical,
  faFloppyDisk,
  faFloppyDiskPen,
  faBookmark,
  faLayerGroup,
  faUserShield,
  faPlay,
  duoHexagonNodes,
  faHexagonNodes,
  duoMagnifyingGlassChart,
  faMagnifyingGlassChart,
  duoChartNetwork,
  faChartNetwork,
  duoDiagramSankey,
  faDiagramSankey,
  faRankingStar,
  faClock,
  thinFaCircleInfo,
  regularFaCircleInfo,
  faDiagramProject,
  faDocker,
  duoArrowsSplitUpAndLeft,
  regularFaSplit,
  faAlignCenter,
  regularFaVolcano,
  faScissors,
  regularFaImageSlash,
  solidFaStar,
  regularFaStar,
  faEye,
  faEyeSlash,
  faEllipsisVertical,
  faLock,
  faGlobe,
];
